import { QuestionPlanIsNoAddressNeeded as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-no-address-needed";

import { usePlanIsNoAddressNeeded } from "./hooks";

export const QuestionPlanIsNoAddressNeeded = () => {
	const { isNoAddressNeeded, onSetIsNoAddressNeeded } = usePlanIsNoAddressNeeded();

	return <Question isNoAddressNeeded={isNoAddressNeeded} onSetIsNoAddressNeeded={onSetIsNoAddressNeeded} />;
};

QuestionPlanIsNoAddressNeeded.displayName = "QuestionPlanIsNoAddressNeeded";
